
<template>
  <div class="block">
    <div class="block-title header">
      <div class="title">资金流水</div>
    </div>
    <cash-flow-list></cash-flow-list>
  </div>
</template>

<script>
import List from './components/list.vue'
import CashFlowList from './components/cashFlowList.vue'
export default {
  components:{
    List,
    CashFlowList
  }
}
</script>

<style scoped lang="less">
.header{
  display: flex;
  justify-content: space-between;
  .title{
    font-size: 18px;
    font-weight: 700;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/douyin/poiDistribution/cashFlow.vue